/* PackageEditorGeneralTabComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./PackageEditorGeneralTabRenderer");

class PackageEditorGeneralTabComponent extends EventEmitter {
    constructor(packageEditorComponent) {
        super();
        this._packageEditorComponent = packageEditorComponent;
        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._renderer = undefined;
            resolve();
            //TODO set all class members to undefined here
        });
        this.emit("Shutdown");
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START EDITOR TAB METHODS */
    /*******************************************/
    resizeContainer(width, height) {
        this.emit("ResizeContainer", width, height);
    }
    /*******************************************/
    /* END EDITOR TAB METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    get packageEditorComponent() {
        return this.getPackageEditorComponent();
    }
    getPackageEditorComponent() {
        return this._packageEditorComponent;
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = PackageEditorGeneralTabComponent;
